import { render, staticRenderFns } from "./TransactionsModal.vue?vue&type=template&id=0d2fd78a&scoped=true&"
import script from "./TransactionsModal.vue?vue&type=script&lang=js&"
export * from "./TransactionsModal.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsModal.vue?vue&type=style&index=0&id=0d2fd78a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2fd78a",
  null
  
)

export default component.exports